const { data } = require('./localizationData');
const LocalizedStrings = require('react-localization').default;

const strings = new LocalizedStrings(data);
module.exports = strings;



// WEBPACK FOOTER //
// ./src/helper/localization/localization.js